module.exports = __webpack_public_path__ + "static/media/category-bg.e795c2cb.png";